import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { AppProvider } from './AppContext'
import { instalarInterceptador401 } from './sessao'

// Antes de montar: qualquer 401 da API encerra a sessão e leva ao login,
// em vez de deixar a tela branca com o corpo do erro no lugar dos dados.
instalarInterceptador401()

ReactDOM.render(<AppProvider><App /></AppProvider>, document.getElementById('root'))

serviceWorker.unregister()


